export default {
  title: "Сите визити",
  subtitle: "Преглед и управување со сите визити на пациенти",
  comingSoon: "Наскоро",
  description:
    "Оваа функција ќе ви овозможи да ги прегледувате и управувате сите визити на пациенти на едно место.",
  copied: "Копирано во клипборд",
  gender: {
    male: "Машки",
    female: "Женски",
  },
  actions: {
    filter: "Филтрирање на визити",
    refresh: "Освежи",
    viewResults: "Преглед на резултати",
    downloadPdf: "Преземање на резултатите во PDF",
  },
  table: {
    id: "ID",
    idTooltip: "Број на визита",
    copyId: "Копирање на бројот на визита",
    date: "Датум / Време",
    dateTooltip: "Датум и време на визита",
    pid: "ЕМБ",
    patient: "Пациент",
    readiness: "Подготвеност",
    readinessTooltip: "{percent}% готово",
    flags: "Флагови",
    actionsTitle: "Дејства",
    flagsTooltipSingular: "Краток преглед - {count} флагиран",
    flagsTooltipPlural: "Краток преглед - {count} флагирани",
    openRecord: "Преглед на досие на пациент",
    test: "Изследување",
    result: "Резултат",
    flag: "Знаме",
    units: "Единици",
    refRange: "Реф. опсег",
    itemsPerPage: "Елементи по страница",
  },
  preview: {
    toggle: "Преглед",
    newTab: "во нов таб",
    currentTab: "во тековен таб",
  },
  filters: {
    title: "Филтрирање на визити",
    subtitle: "Задајте услови за стеснување на списокот со визити",
    field: "Поле",
    fieldPlaceholder: "Изберете поле",
    fieldHint: "Поле од визита за филтрирање",
    fieldRequired: "Изберете поле",
    operator: "Тип совпаѓање",
    operatorHint: "Начин на споредување на податоците",
    operatorRequired: "Изберете тип",
    value: "Вредност",
    valuePlaceholder: "Внесете вредност",
    valueHint: "Вредност за пребарување во визитите",
    valueRequired: "Внесете вредност",
    add: "Додавање на услов",
    addAnother: "Додавање на услов",
    addFirst: "Додавање на прв услов",
    apply: "Примена на филтри",
    save: "Зачувување",
    clearAll: "Бришење на сите",
    andConnector: "И",
    emptyTitle: "Нема додадени услови",
    emptyDescription: "Додајте услови за филтрирање за да ги стесните визитите во табелата.",
    empty: "Нема филтри. Додајте еден за да го стесните списокот.",
    preview: "FQL преглед",
    fqlPreviewBtn: "Прикажување на FQL",
    fqlPreviewTitle: "FQL Барање",
    removeRow: "Отстранување на услов",
    clearAllTooltip: "Отстранување на сите услови",
    addFilterTooltip: "Додавање на нов услов",
    fields: {
      givenName: "Име",
      middleName: "Презиме",
      familyName: "Фамилија",
      patientId: "ЕМБГ",
      gender: "Пол",
      dateOfBirth: "Датум на раѓање",
      date: "Датум на визита",
    },
    operators: {
      cn: "Содржи",
      sw: "Започнува со",
      ew: "Завршува со",
      eq: "Еднакво на",
    },
    booleanValues: {
      true: "Машки",
      false: "Женски",
    },
    fieldHints: {
      givenName: "Лично (прво) име на пациентот",
      middleName: "Средно име на пациентот",
      familyName: "Фамилијарно (последно) име на пациентот",
      patientId: "Единствен матичен број на граѓанин (ЕМБГ)",
      gender: "Биолошки пол на пациентот",
      dateOfBirth: "Формат: YYYY-MM-DD",
      date: "Формат: YYYY-MM-DD",
    },
  },
  dialogs: {
    errors: {
      serverTitle: "Нешто тргна наопаку",
      serverSubtitle: "Неуспешно вчитување на податоците. Обидете се повторно.",
      networkTitle: "Изгубена врска",
      networkSubtitle: "Нема врска со серверот. Проверете ја интернет врската.",
      timeoutTitle: "Истечено време за чекање",
      timeoutSubtitle:
        "Барањето не беше обработено навреме. Веројатно е привремен проблем — обидете се повторно по малку.",
      authTitle: "Сесијата истече",
      authSubtitle: "Најавете се повторно.",
      unknownTitle: "Неочекувана грешка",
      unknownSubtitle: "Нешто тргна наопаку. Обидете се подоцна.",
      retry: "Повторен обид",
      login: "Најава",
    },
    results: {
      title: "Резултати од визита",
      subtitle: "Број на визита:",
      empty: "Нема пронајдени резултати",
      emptySubtitle: "Нема резултати за прикажување во оваа визита.",
      history: "Погледај историја на изследувањето",
      loading: "Вчитување на резултати од визита\u2026",
    },
    flags: {
      title: "Флагирани резултати",
      subtitle: "{count} флагирани резултати",
      loading: "Вчитување на флагирани резултати\u2026",
    },
  },
  errors: {
    serverTitle: "Нешто тргна наопаку",
    serverSubtitle: "Неуспешно вчитување на визитите. Обидете се повторно.",
    networkTitle: "Изгубена врска",
    networkSubtitle: "Нема врска со серверот. Проверете ја интернет врската.",
    timeoutTitle: "Истечено време за чекање",
    timeoutSubtitle:
      "Барањето не беше обработено навреме. Веројатно е привремен проблем — обидете се повторно по малку.",
    authTitle: "Сесијата истече",
    authSubtitle: "Најавете се повторно.",
    validationTitle: "Невалиден филтер",
    validationSubtitle: "Филтерот не може да се обработи. Поправете и обидете се повторно.",
    unknownTitle: "Неочекувана грешка",
    unknownSubtitle: "Нешто тргна наопаку. Обидете се подоцна.",
    emptyTitle: "Нема пронајдени визити",
    emptySubtitle: "Во системот сè уште нема регистрирани визити.",
    filteredEmptyTitle: "Нема совпаѓачки визити",
    filteredEmptySubtitle: "Нема визити кои одговараат на тековните филтри.",
    retry: "Повторен обид",
    clearFilters: "Исчистување на филтрите",
    editFilters: "Промена на филтрите",
    login: "Најава",
    refreshFailed: "Неуспешно освежување \u2014 се прикажуваат последните познати резултати.",
  },
};
